import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/global-components/CTA.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
